import {
  Box,
  Group,
  Menu,
  rem,
  Text,
  UnstyledButton,
  useMantineTheme,
} from '@mantine/core';
import {
  IconChevronLeft,
  IconChevronRight,
  IconLogout,
  IconSettings,
  IconSun,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export function UserMenu({ setTheme }) {
  const theme = useMantineTheme();
  const navigate = useNavigate();

  const handleLogOut = () => {
    localStorage.clear();
    navigate('/login', { replace: true });
  };

  const handleAdminView = () => {
    navigate('/admin', { replace: true });
  };

  return (
    <Menu shadow="md" width={200} position="right">
      <Menu.Target>
        <Box
          sx={{
            paddingTop: theme.spacing.sm,
            borderTop: `${rem(1)} solid ${
              theme.colorScheme === 'dark'
                ? theme.colors.dark[4]
                : theme.colors.gray[2]
            }`,
          }}>
          <UnstyledButton
            sx={{
              display: 'block',
              width: '100%',
              padding: theme.spacing.xs,
              borderRadius: theme.radius.sm,
              color:
                theme.colorScheme === 'dark'
                  ? theme.colors.dark[0]
                  : theme.black,

              '&:hover': {
                backgroundColor:
                  theme.colorScheme === 'dark'
                    ? theme.colors.dark[6]
                    : theme.colors.gray[0],
              },
            }}>
            <Group>
              <Box sx={{ flex: 1 }}>
                <Text size="sm" weight={500}>
                  {localStorage.getItem('userName')}
                </Text>
                <Text color="dimmed" size="xs">
                  {localStorage.getItem('userEmail')}
                </Text>
              </Box>

              {theme.dir === 'ltr' ? (
                <IconChevronRight size={rem(18)} />
              ) : (
                <IconChevronLeft size={rem(18)} />
              )}
            </Group>
          </UnstyledButton>
        </Box>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Application</Menu.Label>
        <Menu.Item icon={<IconSettings size={14} />} onClick={handleAdminView}>
          Admin
        </Menu.Item>
        <Menu.Item icon={<IconLogout size={14} />} onClick={handleLogOut}>
          Log Out
        </Menu.Item>
        <Menu.Item icon={<IconSun size={14} />} onClick={setTheme}>
          Switch Theme
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
